'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import DefaultAlertDialog from '@/components/DefaultAlertDialog';
type ExternalLinkConfirmModalProps = {
  url: string;
  open: boolean;
  onCancel: () => void;
  /** Called after the URL is opened in a new tab. */
  onConfirm: () => void;
};

/** Leave-site warning shown before opening a user-provided external link. */
export default function ExternalLinkConfirmModal(t0) {
  const $ = _c(25);
  const {
    url,
    open,
    onCancel,
    onConfirm
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== onConfirm || $[1] !== url) {
    t1 = () => {
      window.open(url, "_blank", "noopener,noreferrer");
      onConfirm();
    };
    $[0] = onConfirm;
    $[1] = url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleConfirm = t1;
  let t2;
  if ($[3] !== t || $[4] !== url) {
    t2 = t.rich("external-link-modal.descriptions", {
      actionLink: url,
      p: _temp,
      h6: _temp2
    });
    $[3] = t;
    $[4] = url;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="body1-omni-styles text-vive-primary-20 flex flex-col gap-2">{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const content = t3;
  let t4;
  if ($[8] !== onCancel) {
    t4 = nextOpen => {
      if (!nextOpen) {
        onCancel();
      }
    };
    $[8] = onCancel;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("external-link-modal.title");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("external-link-modal.cancelButtonText");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("external-link-modal.acceptButtonText");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== content || $[17] !== handleConfirm || $[18] !== onCancel || $[19] !== open || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <DefaultAlertDialog open={open} onOpenChange={t4} type="custom" title={t5} content={content} cancelText={t6} actionText={t7} onCancel={onCancel} onAction={handleConfirm} cancelButtonClassName="rounded-full px-5 py-3 border-[1.5px] border-vive-primary-20 text-vive-primary-20 buttonM-omni-styles hover:border-vive-primary-40 hover:text-vive-primary-40 active:text-vive-primary-60 active:border-vive-primary-60" actionButtonClassName="rounded-full px-5 py-3 text-white buttonM-omni-styles bg-vive-brand-50 hover:bg-vive-brand-50/80 active:bg-vive-brand-50/60" />;
    $[16] = content;
    $[17] = handleConfirm;
    $[18] = onCancel;
    $[19] = open;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
function _temp2(chunks_0) {
  return <span className="subheader-2 block font-semibold break-all text-white">{chunks_0}</span>;
}
function _temp(chunks) {
  return <p>{chunks}</p>;
}